//DEFINE THE ACTIONS TO TRIGGER
export const GET_LOGS_LOADING = 'GET_LOGS_LOADING';
export const GET_LOGS_FAIL = 'GET_LOGS_FAIL';
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS';


export type LogsType =  {
    log_id: string;
    log_user: string;
    log_service_name: string;
    log_info: string,
    log_created_at: string;
    event_id: string;
    event_name: string;
    event_description: string;
    event_type: string;
};


export interface GetLogsLoading {
    type: typeof GET_LOGS_LOADING
}

export interface GetLogsFail {
    type: typeof GET_LOGS_FAIL
}

export interface GetLogsSuccess {
    type: typeof GET_LOGS_SUCCESS,
    payload:LogsType
}

export type GetLogsDispatchTypes = GetLogsLoading | GetLogsFail | GetLogsSuccess;